import { XMarkIcon } from "@heroicons/react/24/outline";
import * as Dialog from "@radix-ui/react-dialog";

type Disable2FAModalProps = {
    isOpen: boolean;
    setIsOpen: (open: boolean) => void;
    onDisable: () => void;
};

export const Disable2FAModal = ({ isOpen, setIsOpen, onDisable }: Disable2FAModalProps) => {
    return (
        <Dialog.Root open={isOpen} onOpenChange={setIsOpen}>
            <Dialog.Portal>
                <Dialog.Overlay className="fixed inset-0 z-50 bg-black/40 backdrop-blur-sm" />
                <Dialog.Content className="fixed left-1/2 top-1/2 z-50 w-full max-w-xs -translate-x-1/2 -translate-y-1/2 space-y-4 rounded-xl bg-white p-6 shadow-xl">
                    <div className="flex items-center justify-between">
                        <h2 className="text-lg font-semibold text-gray-800">Disable 2FA?</h2>
                        <Dialog.Close asChild>
                            <button className="text-gray-400 hover:text-gray-600">
                                <XMarkIcon className="h-5 w-5" />
                            </button>
                        </Dialog.Close>
                    </div>

                    <p className="text-sm text-gray-600">
                        Are you sure you want to disable Two-Factor Authentication? This will make
                        your account less secure.
                    </p>

                    <div className="flex justify-end gap-2 pt-2">
                        <Dialog.Close asChild>
                            <button className="rounded bg-gray-100 px-4 py-1.5 text-sm font-medium text-gray-800 hover:bg-gray-200">
                                Cancel
                            </button>
                        </Dialog.Close>
                        <button
                            onClick={() => {
                                onDisable();
                                setIsOpen(false);
                            }}
                            className="rounded bg-red-600 px-4 py-1.5 text-sm font-medium text-white hover:bg-red-700"
                        >
                            Disable
                        </button>
                    </div>
                </Dialog.Content>
            </Dialog.Portal>
        </Dialog.Root>
    );
};
